import styled from 'styled-components';
import v from 'scss/v';
import { I18N } from 'commons/I18N';

const ErrorMessage = styled(I18N)`
  color: rgb(211, 47, 47);
  font-weight: 700;
  margin: 5px 0;

  &__input--field {
    border-color: rgb(211, 47, 47);
    box-shadow: 0 0 6px ${v('$grayscale-gainesboro')};
  }
`;

export default ErrorMessage;
